// lib/utils.js
import { CheckCircle, Truck, Clock, XCircle, AlertTriangle, Loader2 } from 'lucide-react';


export const getStatusConfig = (status) => {
  const configs = {
    pe_drum: {
      color: 'bg-blue-50 text-blue-700 border-blue-200',
      icon: <Truck className="w-4 h-4" />,
      text: 'Pe drum',
    },
    in_incarcare: {
      color: 'bg-amber-50 text-amber-700 border-amber-200',
      icon: <Loader2 className="w-4 h-4 animate-spin" />,
      text: 'În încărcare',
    },
    in_asteptare: {
      color: 'bg-gray-50 text-gray-700 border-gray-200',
      icon: <Clock className="w-4 h-4" />,
      text: 'În așteptare',
    },
    livrat: {
      color: 'bg-emerald-50 text-emerald-700 border-emerald-200',
      icon: <CheckCircle className="w-4 h-4" />,
      text: 'Livrat',
    },
  };

  return configs[status] || {
    color: 'bg-gray-50 text-gray-700 border-gray-200',
    icon: <AlertTriangle className="w-4 h-4" />,
    text: 'Necunoscut',
  };
};


// Formatează valoarea ca RON
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('ro-RO', {
    style: 'currency',
    currency: 'RON',
    minimumFractionDigits: 0
  }).format(value);
};

// Formatează o dată ca dd.mm.yyyy
export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('ro-RO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};
